export const addAnimationOnScroll = () => {
  const body = document.querySelector('body');
  if (body.getAttribute('data-entrance-animations') === 'false') {
    return;
  }

  const elements = document.querySelectorAll('.ism-animate');

  const isInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= windowHeight && rect.right <= windowWidth;
  };

  const checkElements = () => {
    elements.forEach((el) => {
      if (isInViewport(el)) {
        el.classList.add('ism-animated');
      }
    });
  };

  window.addEventListener('scroll', checkElements);
  window.addEventListener('resize', checkElements);
  checkElements(); // Initial check
};
